import React from 'react';
import LoadingButton from '@mui/lab/LoadingButton';

const MutationLoadingButton = ( { mutation, ...buttonProps } ) => {
    // let mutation = props.mutation;
    return <LoadingButton {...buttonProps} loading={ mutation?.isLoading } />;
};

export default MutationLoadingButton;